var path = 'app/scripts/modules/core/src/cluster/filter/collapsibleFilterSection.html';
var html = "<div class=\"collapsible-filter-section\">\n    <a href class=\"section-heading\" ng-click=\"toggle()\">\n      <h4>\n        <span class=\"glyphicon glyphicon-chevron-{{getIcon()}}\"></span>\n        {{heading}}\n        <help-field ng-if=\"helpKey\" key=\"{{helpKey}}\" placement=\"right\"></help-field>\n      </h4>\n    </a>\n  <div class=\"content-body\" ng-if=\"state.expanded\" ng-transclude></div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/cluster/filter/collapsibleFilterSection.html
// module id = 970
// module chunks = 0